import { createStyles } from 'antd-style';

export default createStyles(({ css }) => ({
  // Main container
  container: css`
    height: 100%;
    display: flex;
    flex-direction: column;
  `,

  // Loading state
  loadingContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    gap: 16px;
  `,

  // Error state
  errorContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    gap: 16px;
  `,

  errorTitle: css`
    color: #ff4d4f;
    font-size: 16px;
  `,

  errorMessage: css`
    color: #666;
    font-size: 14px;
  `,

  errorActions: css`
    display: flex;
    gap: 8px;
  `,

  // Toolbar
  toolbar: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
    flex-shrink: 0;
  `,

  toolbarSection: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,

  pageInfo: css`
    font-size: 14px;
    color: #666;
  `,

  zoomInfo: css`
    font-size: 14px;
    color: #666;
    min-width: 60px;
    text-align: center;
  `,

  // PDF content area
  contentArea: css`
    flex: 1;
    overflow: auto;
    padding: 20px;
    display: flex;
    justify-content: center;
    background: #f5f5f5;
  `,

  canvasContainer: css`
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
  `,

  canvas: css`
    display: block;
    max-width: 100%;
    height: auto;
  `,

  // Footer
  footer: css`
    padding: 8px 16px;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
    font-size: 12px;
    color: #666;
    text-align: center;
    flex-shrink: 0;
  `,
}));
